import { EventEmitter } from '@angular/core';
import { DateTimerRefactoryTableDynamicComponent, StatusTramiteComponent, DynamcColumnComponent, RowSelectionCheckboxComponent, NameUserAssignmentComponent } from '@app/shared';

export class FlowConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};

  constructor () {
    const self = this;
    this.settings = {
      mode: 'external',
      noDataMessage: 'Actualmente no hay trámites iniciados',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        idExpediente: {
          title: 'Consecutivo sistema',
          editable: false,
          filter: {
            inputClass: 'form-control',
          },
        },
        radicadoSolicitud: {
          title: 'Radicado solicitud',
          editable: false,
          filter: {
            inputClass: 'form-control',
          },
        },
        radicadoExpediente: {
          title: 'Expediente',
          editable: false,
          filter: {
            inputClass: 'form-control',
          },
        },
        estadoNombre: {
          title: 'Estado expediente',
          editable: false,
          sort: true,
          filter: {
            inputClass: 'form-control',
          },
          // type: 'custom',
          // renderComponent: StatusTramiteComponent,
        },
      },
    };
  }

  /**
   * Genera las columnas dinamicas del calendario de actividades
   *
   * @param {string} key
   * @param {string} title
   * @memberof FlowConfig
   */
  generateColumn(key: string, title: string) {
    this.settings['columns'][key] = {
      title: title,
      editable: false,
      type: 'custom',
      renderComponent: DynamcColumnComponent,
      onComponentInitFunction() {}
    };
  }

  /**
   * Retorna la configuracion de la tabla para los usuarios del grupo seleccionado
   *
   * @returns
   * @memberof FlowConfig
   */
  getSettingsPersistenceUser() {
    const self = this;
    return {
      mode: 'external',
      noDataMessage: 'Actualmente no hay historial',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
          seleccionado: {
          editable: false,
          addable: false,
          // sortDirection: 'asc',
          title: 'Funcionario',
          filter: {
            inputClass: 'form-control',
          },
          type: 'custom',
          renderComponent: RowSelectionCheckboxComponent,
        },
        alias: {
          title: 'Alias',
          editable: false,
        },
        nombre: {
          title: 'Nombre',
          editable: false,
        },
        apellido: {
          title: 'Apellido',
          editable: false,
        },
      }
    };
  }

  getSettingsAddTable(){
    const self = this;
    return {
      mode: 'external',
      noDataMessage: 'Actualmente no hay historial',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
          nombre: {
          editable: false,
          addable: false,
          sortDirection: 'asc',
          title: 'Funcionario',
          filter: {
            inputClass: 'form-control',
          },
          type: 'custom',
          renderComponent: NameUserAssignmentComponent,
        },
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/shared/flow.config.service.ts